<script>
import axios from 'axios'
import store from '@state/store'

export default {
  page: {
    title: 'Forgot Password',
    meta: [
      { name: 'description', content: 'The safehaven Forgot Password Page.' },
    ],
  },

  data() {
    return {
      valid: false,
      emailNotEntered: false,
      isActive: false,
      hasError: false,
      message: '',

      tryingToSendEmail: false,
      canSendEmail: true,
      sendEmailError: null,
      email: '',
      emailRules: [
        (v) => !!v || 'Email address is required',
        (v) =>
          /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()\\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            v
          ) || 'Invalid email address',
      ],
    }
  },

  mounted() {
    store.dispatch('calender/setRecordDetails', { path: null })
  },
  created() {
    store.dispatch('calender/setRecordDetails', { path: null })
  },

  methods: {
    handleSubmit() {
      this.$refs.form.validate()
      if (this.valid) {
        this.tryToSendEmail()
      }
    },

    tryToSendEmail() {
      const orgDetails = JSON.parse(localStorage.getItem('organisationDetails'))
      if (this.email === null || this.email === '') {
        this.isActive = true
        this.hasError = true
        this.emailNotEntered = true
      } else {
        this.tryingToSendEmail = true
        axios
          .post('/api/v1/reset_password/', {
            org_id: orgDetails.org,
            email: this.email.toLowerCase(),
          })
          .then((res) => {
            if (res.status === 200) {
              this.message = 'You will receive an email with instructions'
              this.canSendEmail = false
            }
          })
          .catch((error) => {
            if (error.response.data) {
              this.sendEmailError = error
            } else {
              this.sendEmailError = { response: { data: error.message } }
            }
          })
          .finally(() => {
            this.tryingToSendEmail = false
          })
      }
    },

    goBack() {
      this.$router.go(-1)
    },
  },
}
</script>

<template>
  <v-container fluid>
    <v-row no-gutters justify="center" class="mb-2">
      <v-col cols="12" md="12" align="center" :class="$style.title">
        Password Assistance
      </v-col>
      <v-col
        cols="12"
        md="8"
        class="mt-3"
        align="center"
        :class="$style.forgotPassText"
      >
        Enter your email and we will send you instructions on how to reset your
        password
      </v-col>
    </v-row>

    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
      :class="$style.form"
      @submit.prevent="handleSubmit"
    >
      <v-row :class="$style.text" class="mb-2" no-gutters justify="center">
        <v-col cols="12" md="8">
          <span :class="$style.textLabel">Email</span
          ><span :class="$style.mandatory">*</span>
        </v-col>
        <v-col cols="12" md="8" class="mt-2">
          <v-text-field
            v-model="email"
            hide-details="auto"
            autocomplete="off"
            single-line
            outlined
            dense
            :rules="emailRules"
            :class="{ 'error--text': isActive, 'text-danger': hasError }"
            @keydown="sendEmailError = null"
            @keyup="message = null"
          >
          </v-text-field>

          <v-row v-if="message" justify="center">
            <p
              :class="$style.successMsg"
              class="alert alert-success mt-5"
              role="alert"
            >
              {{ message }}
            </p>
          </v-row>
          <v-row v-else-if="sendEmailError">
            <p
              v-if="email"
              no-gutters
              justify="start"
              :class="$style.serverErrorMsg"
            >
              {{ sendEmailError.response.data }}
            </p>
          </v-row>
        </v-col>
      </v-row>
    </v-form>

    <v-row justify="center" no-gutters>
      <v-col cols="12" md="8" class="mt-4" align="center">
        <v-btn
          hide-details="auto"
          type="submit"
          class="my-auto text-capitalize primary-btn w-m-90-btn"
          :loading="tryingToSendEmail"
          @click="handleSubmit"
          >Submit
        </v-btn>
      </v-col>
    </v-row>

    <v-row :class="$style.termsRow" justify="center">
      <v-col cols="12" md="12" class="btnWarrp ma-auto" align="center">
        <div
          class="clickable primary--text"
          :class="$style.hrRouterLinkText"
          @click="goBack"
          ><v-icon color="primary">mdi-chevron-left</v-icon>Back</div
        >
      </v-col>
    </v-row>
  </v-container>
</template>

<style lang="scss" module>
@import '@design';

.mandatory {
  color: #da1414;
}
.title {
  font-size: 1.35em;
}
.textLabel {
  font-size: 12px;
  font-weight: 700;
}
.forgotPassText {
  margin: 0.5rem auto;
  font-size: 14px !important;
  color: #2c3a4b;
}
.textField {
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.75px;
}
.signUpText {
  font-size: 12px;
  color: #858c94;
}
.inlineLink {
  display: inline;
}

.serverErrorMsg {
  margin-top: 14px;
  margin-left: 20px;
  font-size: 12px;
  color: #ca024f;
}

.successMsg {
  margin-top: -15px;
  margin-left: 12px;
  font-size: 12px;
  color: #42ac53;
}

.termsRow {
  right: 18px;
  width: 100%;
}

.hrRouterLinkText {
  font-family: $system-default-font-family;
  font-size: 14px;
  font-weight: 400;
  line-height: 32px;
  letter-spacing: 1px;
}
</style>
